<div class="devices-container h-auto md:max-w-7xl md:p-4 mb-5">
  <div class="devices-header md:p-0 p-4">
    <h1>Deine Anlagen</h1>

    <div class="filter-section">
      <input
        type="text"
        class="filter-input"
        placeholder="Nach Name filtern..."
        (input)="onFilterChange($event)"
      />
    </div>
  </div>

  <div class="locations-list md:gap-4">
    @for (location of filteredLocations(); track location.id) {
      <div class="location-box md:gap-2 wrap-break-word border-t md:border-r md:border-b md:border-l
      md:pb-5 md:rounded-lg border-gray-200 grid md:grid-cols-[15%_85%] grid-cols-1 gap-5"
           (click)="onSelectLocation(location)"
           (keyup.enter)="onSelectLocation(location)"
           role="button"
           tabindex="0">
        <div class="location-image">
          <img src="/assets/app_icon_dashboard.svg" alt="Location icon" class="icon">
        </div>
        <div class="location-details">
          <div class="field-value">
            <span class="field">Name:</span>
            <span class="value location-name">{{ location.name }}

              @if (getLocationStatus(location.id) === 'ok') {
                <span class="status-ok status md:pl-8">
                  <span class="status-checkbox"><img src="/../assets/status-ok.png" alt="status ok sign"></span>
                  OK
                </span>
              } @else {
                <span class="status-failure status md:pl-8">
                  <span class="status-circle"></span>
                  Fehler
                </span>
              }

            </span>
          </div>

          <div class="field-value">
            <span class="field">Speicher Größe:</span>
            <span class="value">{{ formatLocationValue(location.storageCapacitykWh, 'kWh') }}</span>
          </div>

          <div class="field-value">
            <span class="field">PV Peak:</span>
            <span class="value">{{ formatLocationValue(location.pvPeakkWp, 'kWp') }}</span>
          </div>

          <div class="field-value">
            <span class="field">Adresse:</span>
            <span class="value">{{ location.address }}</span>
          </div>

<!--          <div class="field-value location-id">-->
<!--            <span class="field">ID:</span>-->
<!--            <span class="value">{{ location.id }}</span>-->
<!--          </div>-->
<!--          <div class="field-value">-->
<!--            <span class="field">Max. Leistung <br>Produktion:</span>-->
<!--            <span class="value">{{ location.maxEnergykWh }} KW</span>-->
<!--          </div>-->
<!--          <div class="field-value">-->
<!--            <span class="field">Max. Speicher</span>-->
<!--            <span class="value">{{ location.maxBatteryCharge }} KW</span>-->
<!--          </div>-->

         <!-- <div class="field-value">
            <span class="field">Max Display Power:</span>
            <span class="value">{{ location.maxDisplayEnergykWh }} KW</span>
          </div>-->



        </div>
      </div>
    }
  </div>
</div>
